export default {
    name: 'mycologicalRegistry',
    serverName: '/api/v1/mycological_calculator/mycological_calculator_reestr/',
    apiUrl: '/api/v1/mycological_calculator/mycological_calculator_reestr/',
    userUrl: '/api/v1/teleagronom_user/owners/',
    fieldUrl: '/api/v1/mordovia/field_info/',
    fileUploadUrl: '/api/v1/mycological_calculator/imap_picture/'
};
